export const GET_ALERT_REQUEST = "GET_ALERT_REQUEST";
export const GET_ALERT_SUCCESS = "GET_ALERT_SUCCESS";
export const GET_ALERT_ERROR = "GET_ALERT_ERROR";
